module.exports = __webpack_public_path__ + "static/AI-character-9b7667968b1959189708583cce762208.jpg";